<template>
  <div class="channel-header">
    <div class="channel-info">
      <div class="channel-avatar" :style="{ backgroundImage: `url(${category.iconUrl})` }"></div>
      <div class="channel-meta">
        <div class="channel-name">{{ category.name }}</div>
      </div>
    </div>
    <div class="action-buttons">
      <like-button :customClass="`action-btn`" :item="video" @handleClickLike="$emit('handleLikeVideo')" />
    </div>
  </div>
</template>
<script>
import LikeButton from './LikeButton'

export default {
  props: {
    video: {
      type: Object,
      default () {
        return {}
      }
    },
    category: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    LikeButton
  }
}
</script>
<style scoped>
.channel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  flex-wrap: wrap;
  gap: 12px;
}

.channel-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.channel-meta {
  display: flex;
  flex-direction: column;
}

.channel-name {
  font-weight: bold;
  font-size: 14px;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/view/video/components/VideoHeader.vue